// import React from "react";

import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import authAxios from "../../components/authAxios";


import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";


import {Radio, message } from "antd";

import UserAlerts from "../../components/UserAlerts";
import DashboardHeader from "../../components/DashboardHeader";

import NumberFormat from "react-number-format";

import { extractErrorMessage } from "../../components/errorUtils";


function BulkCreateMeters() {
    const location = useLocation();
    const queryClient = useQueryClient();
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');
    
    const property = location.state.property;
    const [sku, setSku] = useState('');
    const [price, setPrice] = useState('');
    const [eventType, setEventType] = useState('10');

    const { data: products } = useQuery({
        queryKey: ['products'],
        queryFn: async () => {
            const response = await authAxios.get("/products/skus/");
            return response.data;
        },
    });

    const handleConfirmedPrice = (e) => {
        const amt = parseFloat(e.target.value.replace(/,/g, ''));
        setPrice(amt)
    }

    const mutation = useMutation({
        mutationFn: (meter) => {
            return authAxios.post("/rentals/bulk-create-meters/", meter);
        },
        // onError: (error, variables, context) => {
        //     console.log("ERROR",error)

        //     if (error.response.data.error){
        //         // If it's an array, display each error message
        //         if (Array.isArray(error.response.data.error)) {
        //             error.response.data.error.map((errorMessage) => (
        //                 setError(errorMessage)
        //             ));
        //         } else {
        //             // Handle single error message
        //             setError(error.response.data.error); 
        //         }
        //     } else {
        //         // Fallback to Standard error message
        //         setError(error.message); 
        //     }      
        // },
        onError: (error, variables, context) => {
            console.log("ERROR",error)
            const errorMessage = extractErrorMessage(error.response?.data) || error.message;
            setError(errorMessage);
        },
        onSuccess: (result) => {
            message.success(`${result.data.message}`);
            queryClient.invalidateQueries(['meters']);
            navigate('/dashboard/meters/');
        },
    })

    const updateMutation = useMutation({
        mutationFn: (meterData) => {
            // return authAxios.put(`rentals/bulk-create-meters/${property.id}/bulk-create-meters/`, meterData);
            return authAxios.put("/rentals/bulk-update-meters/", meterData);

        },
        onError: (error, variables, context) => {
            console.log("ERROR",error)

            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            message.success(`${result.data.message}`);
            queryClient.invalidateQueries(['meters']);
            navigate('/dashboard/meters/');
        },
    })


    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (!property){
            setError("Property is required")
            return
        }

        if (!sku){
            setError("Please select the Utility Product")
            return
        }

        if (price === null || price === '' || isNaN(price) || Number(price) <= 0) {
            setError("Please enter a valid Price Per Unit (must be greater than zero)");
            return;
        }

        if (eventType ==="10") {
            const property_id = property.id
            const sku_id = sku
            const meter = { client, property_id, sku_id, price, user, sku };
            console.log(meter)
            mutation.mutate(meter)
        } else if (eventType==="20") {
            const property_id = property.id
            const sku_id = sku
            const meterData = { client, property_id, sku_id, price, user, sku };
            console.log(meterData)
            updateMutation.mutate(meterData)
        }   
  }

    return(
        <div className="dashboard-main">
            <section className="dashboard-content">

            <section className="dashboard-form dashboard-form-compact">
                <UserAlerts error={error} />
                <DashboardHeader dashboardTitle="Bulk Meter Management" dashboardPreTitle="Properties" />

                <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                    <Radio.Group 
                        onChange={(e) => setEventType(e.target.value)} 
                        className="custom-input"
                        value={eventType}
                    >
                        <Radio value="10">Create</Radio>
                        <Radio value="20">Edit</Radio>

                    </Radio.Group>

                    <TextField className="custom-input"
                        label="Property"
                        variant="outlined" 
                        fullWidth
                        defaultValue = {property.name}
                        InputProps={{ readOnly: true }}
                    />

                    <Autocomplete
                        onChange={(event, newValue) => {
                            setSku(newValue.id)
                            setPrice(newValue.price)
                            }}
                        options={products}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => 
                            <TextField 
                                className='custom-input'
                                label="Product" 
                                {...params} 
                            />
                        }
                    />

                    <NumberFormat 
                        value={price}
                        onChange={(e) => handleConfirmedPrice(e)} 
                        className="custom-input"
                        fullWidth
                        label="Price Per Unit" 
                        variant="outlined" 
                        customInput={TextField}
                        thousandSeparator={true} 
                    />

                    <div className="button-border-top">
                        <button id="submit" className="btn btn-primary form-buttons" type="submit">
                            Submit
                        </button>
                    </div>
                </form>

            </section>
            </section> 

        </div>
    )

}

export default BulkCreateMeters;
